/**
 * Table des Matières - Dawn 15.4
 * Exclut : .blog-products-title et .card__heading
 */

document.addEventListener('DOMContentLoaded', function() {
  const articleContent = document.querySelector('.article-template__content');
  
  if (!articleContent) {
    return;
  }

  let allHeadings = articleContent.querySelectorAll('h2, h3');
  
  const headings = Array.from(allHeadings).filter(heading => {
    const classList = heading.classList;
    
    if (classList.contains('blog-products-title')) {
      return false;
    }
    
    if (classList.contains('card__heading')) {
      return false;
    }
    
    if (heading.closest('.blog-products-title') || heading.closest('.card__heading')) {
      return false;
    }
    
    return true;
  });
  
  if (headings.length === 0) {
    return;
  }

  try {
    const tocContainer = document.createElement('div');
    tocContainer.className = 'table-of-contents';
    tocContainer.innerHTML = '<h2 class="toc-title">Sommaire</h2>';
    
    const tocList = document.createElement('ul');
    tocList.className = 'toc-list';
    
    let currentH2List = null;

    headings.forEach((heading, index) => {
      if (!heading.id) {
        const id = 'section-' + heading.textContent
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
        heading.id = id + '-' + index;
      }

      const listItem = document.createElement('li');
      const link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent;
      link.className = 'toc-link';
      
      link.addEventListener('click', function(e) {
        e.preventDefault();
        const target = document.getElementById(heading.id);
        if (target) {
          const offset = 80;
          const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
          
          history.pushState(null, null, '#' + heading.id);
        }
      });

      listItem.appendChild(link);

      if (heading.tagName === 'H2') {
        listItem.className = 'toc-item toc-h2';
        tocList.appendChild(listItem);
        currentH2List = null;
      } else if (heading.tagName === 'H3') {
        listItem.className = 'toc-item toc-h3';
        
        if (!currentH2List) {
          currentH2List = document.createElement('ul');
          currentH2List.className = 'toc-sublist';
          
          const lastH2 = tocList.querySelector('li.toc-h2:last-child');
          if (lastH2) {
            lastH2.appendChild(currentH2List);
          } else {
            tocList.appendChild(listItem);
            return;
          }
        }
        
        currentH2List.appendChild(listItem);
      }
    });

    tocContainer.appendChild(tocList);

    const tocPlaceholder = document.querySelector('.toc-placeholder');
    if (tocPlaceholder) {
      tocPlaceholder.appendChild(tocContainer);
    } else {
      articleContent.insertBefore(tocContainer, articleContent.firstChild);
    }

    addScrollSpy(headings);
    
  } catch (error) {
    // Erreur silencieuse
  }
});

function addScrollSpy(headings) {
  const tocLinks = document.querySelectorAll('.toc-link');
  
  window.addEventListener('scroll', function() {
    let current = '';
    const scrollPosition = window.pageYOffset + 100;

    headings.forEach(heading => {
      const sectionTop = heading.offsetTop;
      if (scrollPosition >= sectionTop) {
        current = heading.id;
      }
    });

    tocLinks.forEach(link => {
      link.classList.remove('active');
      if (link.getAttribute('href') === '#' + current) {
        link.classList.add('active');
      }
    });
  });
}
